import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./components/Header";

const AdminLayout = () => {
  

  
  return (
    <div>
      <Header />
      <Outlet />
    </div>
  );
};

export default AdminLayout;
